import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Download = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth={3}
        d="M9.5 14.75l6 6m6-6l-5.682 5.682M15.5 20V6"
      />
      <path fill="currentColor" d="M1 19h3v11H1z" />
      <path fill="currentColor" d="M1 27h29v3H1z" />
      <path fill="currentColor" d="M27 19h3v9h-3z" />
    </g>
  </svg>
)
